module.exports = __webpack_public_path__ + "img/Myanmar.16efd971.svg";